import { render, staticRenderFns } from "./template.html?vue&type=template&id=270bd4fd&"
import script from "./component.vue?vue&type=script&lang=js&"
export * from "./component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('270bd4fd')) {
      api.createRecord('270bd4fd', component.options)
    } else {
      api.reload('270bd4fd', component.options)
    }
    module.hot.accept("./template.html?vue&type=template&id=270bd4fd&", function () {
      api.rerender('270bd4fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/views/common/object/component/form/elementLp2/fetchSuggestSelect/component.vue"
export default component.exports